import { render } from "./DashboardCardsTodayInformations.vue?vue&type=template&id=f3efbe2e&ts=true"
import script from "./DashboardCardsTodayInformations.vue?vue&type=script&lang=ts"
export * from "./DashboardCardsTodayInformations.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__